//
// Renders video ads.
function AdsNinjaVideoRenderer(logger){
    
    this.__logger      = logger || new AdsNinjaLogger();
    this.videoPlayers  = {};
    this.__eventHelper = new AdsNinjaEventHelper();
}

var noMuteButtonBrands = ['CarBuzz', 'TheSportster', 'TopSpeed', 'SimpleFlying', 'TheGamer'];

//
// Clears ad progress and start timeouts.
// timeoutType = adProgressTimeouts | adStartTimeouts
function clearAdTimeout(adElementId, timeoutType) {
  window.adsNinjaHeaderBiddingManager[timeoutType] = window.adsNinjaHeaderBiddingManager[timeoutType] || {};
  var currentTimeout = window.adsNinjaHeaderBiddingManager[timeoutType][adElementId];

  if (currentTimeout) {
    clearTimeout(currentTimeout);
  }
}

//
// Set ad start timeouts.
function setAdStartTimeout(adElementId, handleAdError) {
  window.adsNinjaHeaderBiddingManager['adStartTimeouts'] = window.adsNinjaHeaderBiddingManager['adStartTimeouts'] || {};
  var currentTimeout = window.adsNinjaHeaderBiddingManager['adStartTimeouts'][adElementId];

  if (!currentTimeout) {
    var newTimeout = setTimeout(function() {
      handleAdError();
    }, 10000);

    window.adsNinjaHeaderBiddingManager['adStartTimeouts'][adElementId] = newTimeout;
  }
}

//
// Set ad progress timeouts.
function setAdProgressTimeout(adElementId, handleAdError) {
  window.adsNinjaHeaderBiddingManager['adProgressTimeouts'] = window.adsNinjaHeaderBiddingManager['adProgressTimeouts'] || {};
  window.adsNinjaHeaderBiddingManager['adProgressTime'] = window.adsNinjaHeaderBiddingManager['adProgressTime'] || {};
  var currentAdProgressTime = window.adsNinjaHeaderBiddingManager['adProgressTime'][adElementId];

  if (typeof(currentAdProgressTime) !== 'undefined') {
    var newTimeout = setTimeout(function() {
      var newAdProgressTime = window.adsNinjaHeaderBiddingManager['adProgressTime'][adElementId];

      if (currentAdProgressTime === newAdProgressTime) {
        handleAdError();
      } else {
        setAdProgressTimeout(adElementId, handleAdError);
      }
    }, 4000);

    window.adsNinjaHeaderBiddingManager['adProgressTimeouts'][adElementId] = newTimeout;
  }
}

//
// Renders video ads.
AdsNinjaVideoRenderer.prototype.render = function(options){

    // Validate options.
    if(!options || options['type'] !== 'video' || !options.hasOwnProperty('video') || !options['video'] || 0 === Object.keys(options['video']).length){

        this.__logger.error('Invalid options.', options, false);
        return;
    }

    if(!window.google || !window.google.ima){

        this.__logger.error('Google IMA SDK not found.', options, false);
        return;
    }

    try{

        switch(options['headerBiddingLibrary']){

            case 'prebid':
    
                this.__logger.debug(`Rendering Prebid video ad.`, options, false);
                this.__renderPrebidAd(options);
    
                break;
    
            case 'amazon':
    
                this.__logger.debug(`Rendering Amazon video ad.`, options, false);
                this.__renderAmazonAd(options);

                break;

            case 'google':

                this.__logger.debug(`Rendering GAM video ad.`, options);
                this.__renderGoogleAd(options);

                break;

            case 'direct':

                this.__logger.debug(`Rendering Direct VAST video ad.`, options);
                this.__renderDirectAd(options);

                break;
    
            default:
    
                this.__logger.error(`Invalid render header bidding library: ${options['headerBiddingLibrary']}.`, options, false);
    
                break;
        }
    }
    catch(error){

        var errorData = {
            error: error,
            renderingOptions: options,
        };

        this.__logger.error(error.toString(), errorData, false);
    }
}

//
// Renders Prebid video ads.
AdsNinjaVideoRenderer.prototype.__renderPrebidAd = function(options){

    // Validate options.
    if(!options 
        || !options.hasOwnProperty('video') 
        || !options['video'] 
        || 0 === Object.keys(options['video']).length
        || !options['video'].hasOwnProperty('adElementId') 
        || !options['video']['adElementId']
        || !options['video'].hasOwnProperty('width')
        || !options['video']['width']
        || !options['video'].hasOwnProperty('height')
        || !options['video']['height']
    ){

        this.__logger.error('Invalid render options.', options, false);
        return;
    }

    var adElementId = options['video']['adElementId'];
    var width       = options['video']['width'];
    var height      = options['video']['height'];

    if (window.adsNinjaHeaderBiddingManager.getBrandName() === 'TopSpeed') {

        this.__renderVastAd(adElementId, width, height, options['video']['vastXml'], options, options['video']['vastUrl']);
    } else {
        if(options['video'].hasOwnProperty('vastXml') && options['video']['vastXml']){

            this.__renderVastAd(adElementId, width, height, options['video']['vastXml'], options);
        }
        else if(options['video'].hasOwnProperty('vastUrl') && options['video']['vastUrl']){

            this.__downloadVastAd(
                options['video']['vastUrl'], 
                this.__successCallback.bind(this, adElementId, width, height, options), 
                this.__errorCallback.bind(this, adElementId, options)
            );
        
        }
        else{

            this.__logger.error('Invalid render options.', options, false);
            window.adsNinjaHeaderBiddingManager.handleAdZoneForceEvents(adElementId);
        }
    }

};

//
// Renders GAM video ads.
AdsNinjaVideoRenderer.prototype.__renderGoogleAd = function(options){

    // Validate options.
    if(!options 
        || !options.hasOwnProperty('video') 
        || !options['video'] 
        || 0 === Object.keys(options['video']).length
        || !options['video'].hasOwnProperty('adUnit') 
        || !options['video'].hasOwnProperty('width')
        || !options['video']['width']
        || !options['video'].hasOwnProperty('height')
        || !options['video']['height']
        || !options['video']['vastXml']
    ){

        this.__logger.error('Invalid render options.', options);
        return;
    }

    var adElementId = options['video']['adUnit'];
    var width       = options['video']['width'];
    var height      = options['video']['height'];
    var vastXml     = options['video']['vastXml'];

    var renderResult = this.__renderVastAd(adElementId, width, height, vastXml);
    
    // TODO: Revisit this.
    if(renderResult){

        var helperResult = this.__renderGoogleAdHelper(adElementId);
        
        if(!helperResult){

            this.__logger.error(`Cannot fix Google video ad rendering style. Unable to find ad element with id: ${adElementId}.`, {
                adElementId: adElementId,
                width: width,
                height: height,
                vastXml: vastXml,
                debugInfo: debugInfo,
            });
        }
    }
};

//
// Google VAST ad render helper.
AdsNinjaVideoRenderer.prototype.__renderGoogleAdHelper = function(adElementId){

    // TODO: Revisit this.
    var ad = window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);

    if(!ad){

        return false;
    }

    var adElement = ad.getAdElement();

    if(!adElement){

        return false;
    }

    var adElementInline = ad.getAdZoneInlineElement();

    if(!adElementInline){

        return false;
    }

    if(window.adsNinjaHeaderBiddingManager.isAdFloatingOrAlwaysFloating(adElementId)){

        adElementInline.style.display = 'block';
    }
    
    return true;
};

//
// Renders Direct Deal VAST video ads.
AdsNinjaVideoRenderer.prototype.__renderDirectAd = function(options){
    // Validate options.
    if(!options
        || !options['video']
        || !options['video']['adUnit']
        || !options['video']['vastUrl']
    ){

        this.__logger.error('Invalid render options.', options);
        return;
    }

    var adElementId = options['video']['adUnit'];
    var adElement   = document.getElementById(adElementId);
    var width       = adElement.closest('.ad-zone').getBoundingClientRect().width;
    var height      = width * 9/16;
    adElement.parentNode.style.width = '100%';

    this.__renderVastAd(adElementId, width, height, options['video']['vastXml'], options, options['video']['vastUrl']);
};

//
// Renders Amazon video ads.
AdsNinjaVideoRenderer.prototype.__renderAmazonAd = function(options){

    // Validate options.
    if(!options 
        || !options.hasOwnProperty('video') 
        || !options['video'] 
        || 0 === Object.keys(options['video']).length
        || !options['video'].hasOwnProperty('adUnit') 
        || !options['video']['adUnit']
        || !options['video'].hasOwnProperty('vastUrl')
        || !options['video']['vastUrl']
    ){

        this.__logger.error('Invalid render options.', options, false);
        return;
    }

    var data = window.adsNinjaHeaderBiddingManager.getAdUnitSlotDetails('amazon', options['video']['adUnit']);

    if(!data 
        || 0 === Object.keys(data).length 
        || !data.hasOwnProperty('adElementId') 
        || !data['adElementId'] 
        || !data.hasOwnProperty('video') 
        || !data['video'] 
        || 0 === Object.keys(data['video']).length
    ){

        this.__logger.error('Invalid render options.', options, false);
        return;
    }

    var adElementId = data['adElementId'];
    var width       = data['video']['width'];
    var height      = data['video']['height'];

    this.__downloadVastAd(
        options['video']['vastUrl'], 
        this.__successCallback.bind(this, adElementId, width, height, options), 
        this.__errorCallback.bind(this, adElementId, options)
    );
};

//
// Renders in-banner video ads.
AdsNinjaVideoRenderer.prototype.__renderVastAd = function(adElementId, width, height, vastXml, debugInfo = {}, vastUrl = null){
    
    this.__logger.debug('Attempting to render In-banner video ad.', {
        adElementId: adElementId,
        width: width,
        height: height,
        vastXml: vastXml,
        vastUrl: vastUrl,
        debugInfo: debugInfo,
    }, false);

    if(!adElementId || !width || !height || (!vastXml && !vastUrl)){

        this.__logger.error('Invalid render options.', {
            adElementId: adElementId,
            width: width,
            height: height,
            vastXml: vastXml,
            vastUrl: vastUrl,
            debugInfo: debugInfo,
        }, false);

        window.adsNinjaHeaderBiddingManager.handleAdZoneForceEvents(adElementId);
        return false;
    }

    var adElement = document.getElementById(adElementId);

    if(!adElement){

        this.__logger.error(`Cannot init in-banner video. Unable to find ad element with id: ${adElementId}.`, {
            adElementId: adElementId,
            width: width,
            height: height,
            vastXml: vastXml,
            vastUrl: vastUrl,
            debugInfo: debugInfo,
        }, false);

        window.adsNinjaHeaderBiddingManager.handleAdZoneForceEvents(adElementId);
        return false;
    }


    var refreshContainerElement = adElement.closest('.dynamically-injected-refresh-ad-zone');
    var refreshingAdZone        = window.adsNinjaHeaderBiddingManager.refreshingAdZones[adElementId];

    if(!refreshingAdZone || !refreshContainerElement){

        this.__logger.error(`Cannot init in-banner video. There is no refreshing ad zone or container with ad element ID: ${adElementId}.`, {
            adElementId: adElementId,
            width: width,
            height: height,
            vastXml: vastXml,
            vastUrl: vastUrl,
            debugInfo: debugInfo,
        }, false);

        window.adsNinjaHeaderBiddingManager.handleAdZoneForceEvents(adElementId);
        return false;
    }

    // TODO: Make configurable.
    // Wait till video has finished playing before refreshing.
    if(refreshContainerElement && false){

        refreshContainerElement.setAttribute('data-refreshing-allowed', 'false');
    }
    else if(refreshContainerElement){

        refreshContainerElement.setAttribute('data-refreshing-allowed', 'true');
    }

    // IMA SDK Settings

    var adsInitialized             = false;
    var adDisplayContainer         = new window.google.ima.AdDisplayContainer(adElement);
    var adsLoader                  = new window.google.ima.AdsLoader(adDisplayContainer);
    var waypointElementId          = `ad-zone-container-${adElementId}`;
    var inBannerVideoWidth         = width;
    var inBannerVideoHeight        = height;
    var floatingOffset             = inBannerVideoHeight / 2;
    var self                       = this;
    var isAdDoneHandled            = false; // Flag to handle duplicate ad done handling.

    adElement.style.maxHeight      = `${inBannerVideoHeight}px`;
    adElement.style.height         = `${inBannerVideoHeight}px`;
    adElement.style.maxWidth       = `${inBannerVideoWidth}px`;
    adElement.style.position       = 'relative';

    var handleAdDone = function(event){

        if(isAdDoneHandled){

            return;
        }

        isAdDoneHandled = true;

        var refreshContainerElement = adElement.closest('.adsninja-ad-zone');
        adElement.classList.remove('sticky-footer-video');

        clearAdTimeout(adElementId, 'adProgressTimeouts');

        self.__logger.debug(`In-banner video complete for ad element with id: ${adElementId}.`, {
            event: event,
        }, false);

        // TODO: Revisit.
        // var muteButtonElements = adElement.getElementsByClassName('an-btn-mute');

        // if(muteButtonElements && muteButtonElements.length > 0 && muteButtonElements[0]){

        //     muteButtonElements[0].classList.add('is-hidden');
        // }

        // var closeButtonElements = adElement.getElementsByClassName('an-btn-temp-close');

        // if(closeButtonElements && closeButtonElements.length > 0 && closeButtonElements[0]){

        //     closeButtonElements[0].classList.add('is-hidden');
        // }

        if(refreshContainerElement){
            refreshContainerElement.setAttribute('data-refreshing-allowed', 'true');
        }

        window.adsNinjaHeaderBiddingManager.adZoneEventsLog[adElementId].isLoaded = true;
        window.adsNinjaHeaderBiddingManager.adZoneEventsLog[adElementId].isViewed = true;

        adElement.style.height = '';    // Removed height from ad element. This is needed for in-content video ads.
        adElement.innerHTML    = '';

        if(self.videoPlayers.hasOwnProperty(adElementId) && self.videoPlayers[adElementId]){

            // Remove ad element from video players.
            delete self.videoPlayers[adElementId];
        }

        var result = window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'inBannerVideo');

        if(false && !result){ // TODO: Brand specific logic.

            var inBannerVideoFailRefreshInterval = setInterval(function(){

                if(!window.adsNinjaHeaderBiddingManager.refreshAdElement(adElementId, 'inBannerVideo')){

                    self.__logger.debug('Not able to refresh. Timeout buffer changed to 2 sec', {
                        adElementId: adElementId,
                    }, false);
                }
                else{

                    clearInterval(inBannerVideoFailRefreshInterval);
                }

            }, 2000);

            window.adsNinjaHeaderBiddingManager.addRefreshInterval(adElementId, inBannerVideoFailRefreshInterval);
        }
    };


    var handleAdError = function(event){
      
        var error = event;
        var ad    = null;

        if(event && typeof event === 'object' && typeof event.getError === 'function'){

            error = event.getError();
        }

        if(event && typeof event === 'object' && typeof event.getAd === 'function'){

            ad = event.getAd();
        }

        self.__logger.warn('In-banner video ad error.', {
            ad: ad,
            error: error,
            adElementId: adElementId,
            width: width,
            height: height,
            vastXml: vastXml,
            vastUrl: vastUrl,
            debugInfo: debugInfo,
        }, false);

        // Different bids can all have the same erroneous VAST creative
        if (debugInfo && debugInfo.video) {
          // Prebid bad creative.
          if (debugInfo.headerBiddingLibrary && 'prebid' === debugInfo.headerBiddingLibrary && debugInfo.video.extraInfo && debugInfo.video.extraInfo.creativeId && debugInfo.video.extraInfo.bidder) {
            window.adsNinjaHeaderBiddingManager.blacklistVideoCreative(debugInfo.video.extraInfo.creativeId);
            window.adsNinjaHeaderBiddingManager.blacklistVideoBidder(debugInfo.video.extraInfo.bidder);
          }

          // Amazon bad creative.
          if (debugInfo.headerBiddingLibrary && 'amazon' === debugInfo.headerBiddingLibrary && debugInfo.video.kvBid && debugInfo.video.kvBid.kvMap && debugInfo.video.kvBid.kvMap.amzniid && debugInfo.video.kvBid.kvMap.amzniid[0]) {
            window.adsNinjaHeaderBiddingManager.blacklistVideoCreative(debugInfo.video?.extraInfo?.creativeId);

            // Blacklist amazon bidding partner
            if (debugInfo.video.kvBid.kvMap.amznp && debugInfo.video.kvBid.kvMap.amznp[0]) {
              window.adsNinjaHeaderBiddingManager.blacklistVideoBidder(debugInfo.video.kvBid.kvMap.amznp[0]);
            }
          }
        }

        handleAdDone(event);
    };

    this.videoPlayers[adElementId] = {
        adsManager: null,
        adStarted: false,
        paused: false,
        initialized: false,
        play: function(){
          
            this.paused = false;

            if(!this.initialized || !this.adsManager){

                return false;
            }

            if(this.adStarted){

                this.adsManager.resume();
            }
            else{

                if (window.adsNinjaHeaderBiddingManager.getBrandName() === 'TopSpeed') {
                    setAdStartTimeout(adElementId, handleAdError.bind(this, { getError: function() { return 'adStart never happend' }}));
                }

                this.adsManager.start();
            }

            this.adStarted = true;

            return true;
        },
        pause: function(){
          
            this.paused = true;

            if(!this.initialized || !this.adsManager || !this.adStarted){

                return false;
            }

            this.adsManager.pause();

            return true;
        },
        init: function(inBannerVideoWidth, inBannerVideoHeight, viewMode, callback){

            if(!inBannerVideoWidth || !inBannerVideoHeight || !viewMode){

                return;
            }

            this.adsManager.init(inBannerVideoWidth, inBannerVideoHeight, viewMode);

            this.initialized = true;

            if(!this.paused){
                
                this.play();
            }

            if(callback && typeof callback === 'function'){

                callback();
            }
        },
    };

    // Hack to remove ad choices button.
    this.__hideAdChoicesIcon(adElement);

    adsLoader.addEventListener(window.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, function(adsManagerLoadedEvent){

        var adsRenderingSettings                                         = new google.ima.AdsRenderingSettings();
        adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;

        if (window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheTravel') {
            adsRenderingSettings.loadVideoTimeout = 16000;
        }

        // The adElement should be set to the video DOM element.
        var adsManager                            = adsManagerLoadedEvent.getAdsManager(adElement, adsRenderingSettings);
        self.videoPlayers[adElementId].adsManager = adsManager;

        var adStartCallback = function(event){
            if (window.adsNinjaHeaderBiddingManager.getBrandName() === 'TopSpeed') {
              clearAdTimeout(adElementId, 'adStartTimeouts');
            }

            window.adsNinjaHeaderBiddingManager['adProgressTime'] = window.adsNinjaHeaderBiddingManager['adProgressTime'] || {};
            window.adsNinjaHeaderBiddingManager['adProgressTime'][adElementId] = 0;
            setAdProgressTimeout(adElementId, handleAdError.bind(this, event));

            var ad = window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);

            if(ad && ad.isVideoRequestModeDisplay()){

                self.__logger.debug('video ad start playing: seed bids auction');
                window.adsNinjaHeaderBiddingManager.getNewBidsToSeedPool(adElementId);

            }
        };

        // Sometimes ads will stop playing without throwing an error.
        var adProgressCallback = function(event){
            window.adsNinjaHeaderBiddingManager['adProgressTimeouts'] = window.adsNinjaHeaderBiddingManager['adProgressTimeouts'] || {};
            window.adsNinjaHeaderBiddingManager['adProgressTime'] = window.adsNinjaHeaderBiddingManager['adProgressTime'] || {};
            var currentTimeout = window.adsNinjaHeaderBiddingManager['adProgressTimeouts'][adElementId];

            var adData = event.getAdData();
            if (adData && adData.currentTime) {
              window.adsNinjaHeaderBiddingManager['adProgressTime'][adElementId] = adData.currentTime;
            }

            if (!currentTimeout) {
              setAdProgressTimeout(adElementId, handleAdError.bind(this, event));
            }
        };

        var adPausedCallback = function(_event){
            clearAdTimeout(adElementId, 'adProgressTimeouts');
        };
        
        var showMuteButton = function(){

            if(window.adsNinjaHeaderBiddingManager.isAdFloatingOrAlwaysFloating(adElementId) && noMuteButtonBrands.includes(window.adsNinjaHeaderBiddingManager.getBrandName())){

                return;
            }        

            var span       = document.createElement('span');
            span.innerHTML = `
                <span>
                    <?xml version="1.0" encoding="utf-8"?>
                    <!-- Generator: Adobe Illustrator 27.8.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                        <style type="text/css">
                            .st0 {
                                fill: #FFFFFF;
                            }
                        </style>
                        <g id="Layer_1">
                        </g>
                        <g id="Layer_2">
                            <path class="st0" d="M58.9,22.8c-0.5-0.3-1.2-0.2-1.7,0.1L41.5,34.1h-9.2c-3.6,0-6.5,2.9-6.5,6.5V57c0,3.6,2.9,6.5,6.5,6.5h9.2
                            l15.8,11.2c0.5,0.3,1.1,0.4,1.7,0.1c0.5-0.3,0.9-0.8,0.9-1.5V24.3C59.8,23.7,59.5,23.1,58.9,22.8z M29,57V40.6
                            c0-1.8,1.5-3.3,3.2-3.3h8.1v22.9h-8.1C30.4,60.2,29,58.8,29,57z M56.6,70.2l-13-9.2V36.6l13-9.2V70.2z M77.6,48.8
                            c0,4.8-1.9,9.3-5.2,12.7c-0.6,0.6-1.7,0.6-2.3,0c-0.6-0.6-0.6-1.7,0-2.3c2.8-2.8,4.3-6.5,4.3-10.4c0-3.9-1.5-7.6-4.3-10.4
                            c-0.6-0.6-0.6-1.7,0-2.3c0.6-0.6,1.7-0.6,2.3,0C75.8,39.5,77.6,44,77.6,48.8z" />
                        </g>
                        <g id="Layer_3">
                            <path class="st0" d="M50,3c25.9,0,47,21.1,47,47S75.9,97,50,97S3,75.9,3,50S24.1,3,50,3 M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50
                            s50-22.4,50-50S77.6,0,50,0L50,0z" />
                        </g>
                    </svg>
                </span>
                <span>
                    <?xml version="1.0" encoding="utf-8"?>
                    <!-- Generator: Adobe Illustrator 27.8.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                        <style type="text/css">
                            .st0 {
                                fill: #FFFFFF;
                            }
                        </style>
                        <g id="Layer_1">
                            <path class="st0" d="M71.5,23.1c-0.6-0.6-1.7-0.6-2.3,0l-9.4,9.5v-8.3c0-0.6-0.3-1.2-0.9-1.5c-0.5-0.3-1.2-0.2-1.7,0.1L41.5,34.1
                            h-9.2c-3.6,0-6.5,2.9-6.5,6.5V57c0,2.7,1.6,5,3.9,6l-9.1,9.2c-0.6,0.6-0.6,1.7,0,2.3c0.6,0.6,1.7,0.6,2.3,0l48.7-49.1
                            C72.1,24.8,72.1,23.7,71.5,23.1z M56.6,27.4v8.4l-13,13.1V36.6L56.6,27.4z M32.2,60.2c-1.8,0-3.2-1.5-3.2-3.3V40.6
                            c0-1.8,1.5-3.3,3.2-3.3h8.1v14.9l-8,8H32.2z M56.6,44.6l3.2-3.3v32c0,0.6-0.3,1.2-0.9,1.4c-0.5,0.3-1.2,0.2-1.7-0.1L41.5,63.5h-3.7
                            l5.8-5.9V61l13,9.2V44.6z" />
                        </g>
                        <g id="Layer_2">
                        </g>
                        <g id="Layer_3">
                            <path class="st0" d="M50,3c25.9,0,47,21.1,47,47S75.9,97,50,97S3,75.9,3,50S24.1,3,50,3 M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50
                            s50-22.4,50-50S77.6,0,50,0L50,0z" />
                        </g>
                    </svg>
                </span>
            `;

            span.classList.add('an-btn-mute');
            span.classList.add('an-muted');

            span.addEventListener('click', function(){

                var muted = false;

                if(span.classList.contains('an-muted')){

                    span.classList.add('an-unmuted');
                    span.classList.remove('an-muted');
                    adsManager.setVolume(1);
                }
                else{

                    span.classList.add('an-muted');
                    span.classList.remove('an-unmuted');
                    adsManager.setVolume(0);

                    muted = true;
                }

                window.adsNinjaHeaderBiddingManager.log(`Mute toggled for ad element with id: ${adElementId}`, {
                    adElementId: adElementId,
                    muted: muted,
                });
            });

            adElement.prepend(span);
        };

        var showCloseButton = function(){

            if(!window.adsNinjaHeaderBiddingManager.isAdFloatingOrAlwaysFloating(adElementId)){

                return;
            }

            var span       = document.createElement('span');
            span.innerHTML = '&#x2715';

            span.classList.add('an-btn-temp-close');

            span.addEventListener('click', function(event){

                adsManager.pause();

                window.adsNinjaHeaderBiddingManager.handleAdCloseButtonClick(event, window.adsNinjaHeaderBiddingManager.getAdsData(adElementId));

                self.__logger.debug(`Close button clicked for ad element with id: ${adElementId}`, {
                    adElementId: adElementId,
                }, false);
            });

            adElement.prepend(span);
        };

        // Ad event listeners.
        adsManager.addEventListener(window.google.ima.AdEvent.Type.AD_PROGRESS, self.__eventHelper.throttle(adProgressCallback, 500));
        adsManager.addEventListener(window.google.ima.AdEvent.Type.PAUSED, adPausedCallback);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.COMPLETE, handleAdDone);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.SKIPPED, handleAdDone);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.AD_BREAK_FETCH_ERROR, handleAdError);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.USER_CLOSE, handleAdDone);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.ALL_ADS_COMPLETED, handleAdDone);
        adsManager.addEventListener(window.google.ima.AdErrorEvent.Type.AD_ERROR, handleAdError);
        adsManager.addEventListener(window.google.ima.AdEvent.Type.STARTED, adStartCallback);

        adElement.style.position = 'relative';
        
        // Mute the ad for autoplay
        adsManager.setVolume(0);

        if(!adsInitialized){

            adDisplayContainer.initialize();

            adsInitialized = true;
        }

        if(window.adsNinjaHeaderBiddingManager.isAdFloatingOrAlwaysFloating(adElementId)){

            if(self.videoPlayers.hasOwnProperty(adElementId) && self.videoPlayers[adElementId] && self.videoPlayers[adElementId].adStarted){

                adsManager.resume();
            }
            else if(self.videoPlayers.hasOwnProperty(adElementId) && self.videoPlayers[adElementId]){

                self.videoPlayers[adElementId].init(inBannerVideoWidth, inBannerVideoHeight, google.ima.ViewMode.NORMAL, function(){
                    
                    // Show buttons.
                    showMuteButton();
                    showCloseButton();
                });
            }
        }
        else{

            if(!window.adsNinjaHeaderBiddingManager.inBannerAdZones.hasOwnProperty(adElementId)){

                window.adsNinjaHeaderBiddingManager.inBannerAdZones[adElementId] = [];
            }

            var zone = window.adsNinja.zoneDelegate.getByElementId(adElementId);

            if(!zone){

                this.logger.warn('Unable to setup floating for ad zone: zone does not exist!', {
                    adElementId: adElementId,
                });
                return;
            }

            // TODO: Reuse the observer.
            var zone = window.adsNinja.zoneDelegate.getByElementId(adElementId);

            if(!zone){

                this.logger.warn('Unable to setup floating for ad zone: zone does not exist!', {
                    adElementId: adElementId,
                });
                return;
            }

            var zoneElement = zone.getElement();

            if(!zoneElement){

                this.logger.warn('Unable to setup floating for ad: zone elements does not exist!', {
                    adElementId: adElementId,
                });
                return;
            }

            var observer = new IntersectionObserver(function(entries, observer){

                entries.forEach(function(entry){

                    if(entry.isIntersecting){

                        if(self.videoPlayers.hasOwnProperty(adElementId) && self.videoPlayers[adElementId] && self.videoPlayers[adElementId].adStarted){
                            
                            adsManager.resume();
                        } 
                        else if(self.videoPlayers.hasOwnProperty(adElementId) && self.videoPlayers[adElementId]){
                            
                            self.videoPlayers[adElementId].init(inBannerVideoWidth, inBannerVideoHeight, google.ima.ViewMode.NORMAL, function() {
                                // Show buttons.
                                showMuteButton();
                                showCloseButton();
                            });
                        }
                    }
                    else if(self.videoPlayers.hasOwnProperty(adElementId) && self.videoPlayers[adElementId] && self.videoPlayers[adElementId].adStarted){
                        
                        adsManager.pause();
                    }
                });
            });

            observer.observe(zoneElement);

            window.adsNinjaHeaderBiddingManager.inBannerAdZones[adElementId].push(observer);
        }
    }, false);

    if(!adsInitialized){

        adDisplayContainer.initialize();

        adsInitialized = true;
    }

    var adsRequest                = new window.google.ima.AdsRequest();
    adsRequest.adTagUrl           = vastUrl || '';

    // Only set this when we don't pass in the vastUrl.
    if (adsRequest.adTagUrl.length === 0) {
      adsRequest.adsResponse      = vastXml;
    }

    adsRequest.linearAdSlotWidth  = inBannerVideoWidth;
    adsRequest.linearAdSlotHeight = inBannerVideoHeight;
    adsRequest.vastLoadTimeout    = 10000;

    if (window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheTravel') {
        adsRequest.vastLoadTimeout = 5000;
    }

    adsRequest.setAdWillAutoPlay(true);
    adsRequest.setAdWillPlayMuted(true);
    adsLoader.requestAds(adsRequest);

    return true;
};

//
// Downloads the vast xml file.
AdsNinjaVideoRenderer.prototype.__downloadVastAd = function(url, successCallback, errorCallback){

    var xhr = new XMLHttpRequest();
    
    xhr.onload = function(){

        if(200 !== xhr.status || !xhr.response || 0 === xhr.response.length){

            errorCallback(xhr.status, xhr.response);
            return;
        }

        successCallback(xhr.response);
    };

    xhr.onerror = function(event){

        errorCallback(xhr.status, xhr.response);
        return;
    };

    xhr.open('GET', url, true);
    xhr.send();
};

//
// Hack to remove ad choices button.
AdsNinjaVideoRenderer.prototype.__hideAdChoicesIcon = function(adElement){
    
    var styleSheet       = document.createElement('style');
    styleSheet.innerText = '#cbb { display: none; }';
    var frames           = adElement.getElementsByTagName('iframe');
    var hidIcon          = false;

    if(frames && frames.length > 0){

        for(var i = 0; i < frames.length; i++){

            try{
    
                var frame = frames[i];
    
                if(!frame || frame.hasOwnProperty('src') && frame.src){

                    continue;
                }

                var myDoc = frame.contentDocument || frame.document || frame.contentWindow;

                if(!myDoc){

                    continue;
                }

                if(myDoc.document){

                    myDoc = myDoc.document;
                }

                if(myDoc.head){

                    myDoc.head.appendChild(styleSheet);

                    hidIcon = true;
                }
                else if(myDoc.body){

                    myDoc.body.appendChild(styleSheet);

                    hidIcon = true;
                }
            }
            catch(error){
    
                continue;
            }    
        }
    }

    if(!hidIcon){

        this.__logger.warn('Unable to hide ad choices button.', false);
    }
};

AdsNinjaVideoRenderer.prototype.__successCallback = function(adElementId, width, height, options, vastXml){

    try{

        this.__renderVastAd(adElementId, width, height, vastXml, options);
    }
    catch(error){

        var errorData = {
            error: error,
            renderingOptions: options,
        };

        this.__logger.error(error.toString(), errorData, false);
    }
};

AdsNinjaVideoRenderer.prototype.__errorCallback = function(adElementId, options, status, response){

    this.__logger.error('File download failed. Forcing refresh.', {
        status: status,
        response: response,
        options: options,
    }, false);

    try{

        window.adsNinjaHeaderBiddingManager.handleAdZoneForceEvents(adElementId);
    }
    catch(error){
        
        var errorData = {
            error: error,
            renderingOptions: options,
        };

        this.__logger.error(error.toString(), errorData, false);
    }
};

//
// Hide mute button.
AdsNinjaVideoRenderer.prototype.hideMuteButton = function(adElement){

    if(!adElement){

        return;
    }

    var muteButtonElements = adElement.getElementsByClassName('an-btn-mute');

    if(muteButtonElements && muteButtonElements.length > 0 && muteButtonElements[0]){

        muteButtonElements[0].classList.add('is-hidden');
    }
};

window.AdsNinjaVideoRenderer = AdsNinjaVideoRenderer;
